import styled from 'styled-components';

import { colors, fontSizes, spaces } from '@gaming1/g1-style';

export const LastConnectionTime = styled.time`
  color: ${colors('topBarText')};
  font-size: ${fontSizes('md')};
  padding-right: ${spaces('sm')};
`;
